import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoComplete } from "@/model";
import autocompleteRepository from "@/repository/autoCompleteRepository";
import { autocompleteQueryKeys } from "./keys";


interface DeleteAutocompletesProps {
    ids?: string[];
    keyword?: string;
    searchType?: string;
}

export const useDeleteAutocompletes = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AutoComplete, AxiosError, DeleteAutocompletesProps>({
        mutationKey: [agentId, "autocomplete", "delete-many"],
        mutationFn: async (props: DeleteAutocompletesProps) => {
            try {
                const res = await autocompleteRepository.deleteMany(agentId, props.ids, props.keyword, props.searchType);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: autocompleteQueryKeys.pageAll(agentId)
            });
        }
    });
};

export const useDeleteAutocomplete = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AutoComplete, AxiosError, string>({
        mutationKey: [agentId, "autocomplete", "delete"],
        mutationFn: async (autocompleteId: string) => {
            try {
                const res = await autocompleteRepository.delete(agentId, autocompleteId);
                return res.data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: autocompleteQueryKeys.pageAll(agentId)
            });
        }
    });
};


